import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../_services/listing/common.service';
import { NiceScrollService } from '../_services/nice-scroll.service';
declare var $: any;
@Component({
    selector: 'app-property-listing',
    templateUrl: './property-listing.component.html',
    styleUrls: ['./property-listing.component.css'],
    standalone: false
})
export class PropertyListingComponent implements OnInit {

  constructor(private commonService: CommonService, private niceScroll: NiceScrollService) { }
  @Input() collection = { count: 0, data: [] };
  @Input() isProcessed = false;
  @Input() IsLoading = true;
  config = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: this.collection.count
  };


  ngOnInit(): void {

  }

  bindListingEvents() {
    // this.commonService.GridLayoutSwitcher();
    //this.niceScroll.scrollToDiv('#container-listing');
  }

  onPageChange(event) {
    this.config.currentPage = event;
  }

  showSlider(item: any) {
    debugger;
    const $lg = $('#dynamicLightGallery');
    $lg.unbind();
    // tslint:disable-next-line: only-arrow-functions
    const imageArray = $.makeArray(item.Images).map(function (image, i) {
      return ({
        src: image,
        thumb: image,
        // tslint:disable-next-line: max-line-length
        subHtml: '<div><h2 ><a href="#" style="color:#fff;">' + item.Title + '</a></h2></div>'
      });
    });

    $lg.lightGallery({
      mode: 'lg-fade',
      cssEasing: 'ease',
      download: false,
      counter: false,
      autoplayControls: false,
      dynamic: true,
      zoom: false,
      fullScreen: false,
      googlePlus: false,
      pinterest: true,
      dynamicEl: imageArray.reverse()
    });

    // tslint:disable-next-line: only-arrow-functions
    $lg.on('onCloseAfter.lg', function(event) {
      $lg.data('lightGallery').destroy(true);
    });
  }
}


